import store from '@/store/index';

export const modalsController = {
  show(type, props = {}) {
    store.dispatch('modalsController/SHOW', { type, props });
  },

  close() {
    store.dispatch('modalsController/CLOSE');
  },

  closeAll() {
    store.dispatch('modalsController/CLOSE_ALL');
  },
};

export default {
  install(Vue) {
    Vue.modals = modalsController;
    Vue.prototype.$modals = modalsController;
  },
};
